import { combineReducers } from "redux";
import one from "./get-one";
import all from "./get-all";
import edit from "./edit";
import newOne from "./new-one";
import deleteOne from "./delete-one";
import shareSession from "./share";
import duplicate from "./duplicate";
import deleteBulk from "./delete-bulk";
import deleteFile from "./delete-file";

const reducer = combineReducers({
  one,
  all,
  edit,
  newOne,
  deleteOne,
  shareSession,
  duplicate,
  deleteBulk,
  deleteFile,
});

export default reducer;
